export default [
  /(.*)/ig,
];
